{
  "colorInputLabel": "{label}、{channelLabel}",
  "colorNameAndValue": "{name} : {value}",
  "colorPicker": "カラーピッカー",
  "colorSwatch": "カラースウォッチ",
  "transparent": "透明",
  "twoDimensionalSlider": "2D スライダー"
}
